/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum ReportFrequency {
    Weekly = 'weekly',
    Monthly = 'monthly'
}

export function ReportFrequencyFromJSON(json: any): ReportFrequency {
    return ReportFrequencyFromJSONTyped(json, false);
}

export function ReportFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportFrequency {
    return json as ReportFrequency;
}

export function ReportFrequencyToJSON(value?: ReportFrequency | null): any {
    return value as any;
}

